:host {
  display: flex;
  align-items: center;
}

slot[name='image']::slotted(*) {
  margin-right: var(--spacer-12);
}

slot[name='title']::slotted(*) {
  font-weight: bold !important;
  font-size: 1.5rem !important;
  line-height: 1.75rem !important;
  margin: 0 0 var(--spacer-3) 0 !important;
  color: var(--theme-primary-text) !important;
}

slot[name='actions']::slotted(*) {
  margin: var(--spacer-10) 0 0 0;
}

slot[name='body'] {
  display: block;
  color: var(--theme-tertiary-text);
  font-size: 1rem;
  margin: 0;
}
